export default "__VITE_ASSET__B159G$QP__"